import { useFormContext } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { CheckboxInput } from '@calendly/ui/components/checkbox-input';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { useCallback, useEffect, forwardRef } from 'react';
import { MaxInviteeInput } from 'components/event_type_edit';
const labelWrapperCss = "l1xrixft";
const LabelWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(labelWrapperCss, props.className)} />;
});
const GroupEventLocked = () => {
  const {
    values: {
      displayGroupOccupancy,
      inviteesLimit
    }
  } = useFormContext();
  return <>
      <BodyText>
        {I18n.t('publisher.event_type_editor.sections.hosts_and_invitees.max_invitees_field_label')}
        :
      </BodyText>
      <BodyText color="muted" weight="bold">
        {inviteesLimit}
      </BodyText>
      <BodyText>
        {displayGroupOccupancy ? I18n.t('publisher.event_type_editor.sections.hosts_and_invitees.group_occupancy_shown') : I18n.t('publisher.event_type_editor.sections.hosts_and_invitees.group_occupancy_hidden')}
      </BodyText>
    </>;
};
const GroupEventFields = () => {
  const {
    values: {
      displayGroupOccupancy
    },
    setFieldValue,
    setFieldTouched,
    validateField
  } = useFormContext();
  useEffect(() => {
    validateField('inviteesLimit');
    setFieldTouched('inviteesLimit');
  }, [setFieldTouched, validateField]);
  const handleChange = useCallback(() => {
    setFieldValue('displayGroupOccupancy', !displayGroupOccupancy);
    setFieldTouched('displayGroupOccupancy');
  }, [displayGroupOccupancy, setFieldTouched, setFieldValue]);
  return <>
      <BodyText id="invitee-limit-label">
        {I18n.t('publisher.event_types.group.invitee_limit.description')}
        :
      </BodyText>
      <div>
        <MaxInviteeInput errorOnInputOnly useUpdatedLabel labelledBy="invitee-limit-label" />
        <LabelWrapper>
          <CheckboxInput aria-label={I18n.t('publisher.event_types.general.display_group_occupancy')} onChange={handleChange} checked={!!displayGroupOccupancy} />
          {I18n.t('publisher.event_types.general.display_group_occupancy')}
        </LabelWrapper>
      </div>
    </>;
};
export const GroupEvent = ({
  isLocked
}) => !isLocked ? <GroupEventFields /> : <GroupEventLocked />;

require("./group_event.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./group_event.js");